import { Bot, Clock, Phone } from "lucide-react";
import type {JSX, FC} from "react";
import { Call } from "../../types";

interface LiveCallCardProps {
  getCallDuration: (call: Call) => string;
  call: Call;
  onClick: () => void;
}


const LiveCallCard:FC<LiveCallCardProps> = ({ getCallDuration, call, onClick }): JSX.Element => {
    

  const getUrgencyColor = (urgency: string) => {
    switch (urgency) {
      case 'emergency': return 'bg-red-100 border-red-300 text-red-800';
      case 'high': return 'bg-orange-100 border-orange-300 text-orange-800';
      case 'medium': return 'bg-yellow-100 border-yellow-300 text-yellow-800';
      case 'low': return 'bg-green-100 border-green-300 text-green-800';
      default: return 'bg-gray-100 border-gray-300 text-gray-800';
    }
  };

  return (
    <button
      onClick={onClick}
      className={`relative border-2 rounded-lg p-4 text-left transition-all hover:shadow-lg ${getUrgencyColor(call.urgencyLevel)}`}
    >
      <div className="absolute top-2 right-2">
        <div className="flex items-center space-x-1">
          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
          <span className="text-xs font-bold">LIVE</span>
        </div>
      </div>

      <div className="flex items-start space-x-3 mb-3">
        <div className="p-2 bg-white rounded-full">
          <Phone className="w-5 h-5 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-gray-900 mb-1">{call.patientName}</h3>
          <p className="text-sm capitalize">{call.purpose}</p>
        </div>
      </div>

      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center space-x-1">
          <Clock className="w-4 h-4" />
          <span className="font-mono font-bold">{getCallDuration(call)}</span>
        </div>
        <div className="flex items-center space-x-1">
          <Bot className="w-4 h-4" />
          <span>AI Handling</span>
        </div>
      </div>

      {call.messages.length > 0 && (
        <div className="mt-3 pt-3 border-t border-current border-opacity-20">
          <p className="text-xs line-clamp-2">
            <strong>Latest:</strong> {call.messages[call.messages.length - 1].content}
          </p>
        </div>
      )}
    </button>
  );
};

export default LiveCallCard;